import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import {
  FINANCE,
  FINANCE_AMOUNT,
  FORM_BP,
  FORM_MG,
  FORM_MG_NO_SHOP,
  PENDIENTES_DE_DATOS,
  REQUEST_BASIC_CONTACT,
  REQUEST_MODE_EDIT,
  REQUEST_MODE_VIEW,
} from '@app/@core/constants/requests.constants';
import { RequestsSaveSendStore } from '@app/requests/requests-save-send-service/requests-save-send.store';
import { POINT_OF_SALE, REQUEST_DATA } from '@app/@core/constants/requests.constants';
import { CustomValidatorsService } from '@app/@shared/custom-validators/custom-validators.service';
import { CommonDataDTO } from '@app/requests/model/combos-model';
import { StatesFieldsFrontDTO } from '@app/requests/model/requests-model';

@Component({
  selector: 'scf-request-basic-contact',
  templateUrl: './request-basic-contact.component.html',
  styleUrls: ['./request-basic-contact.component.scss'],
})
export class RequestBasicContactComponent implements OnInit {
  @Input() public request: any = null;
  @Input() state: CommonDataDTO;
  @Input() public mode: string = 'new';
  @Input('operative') set operative(data: any) {
    this.operativeValue = data;
    if (data) {
      if (data === 'EIC' && this.requestStore.listaFormulariosConsumo.includes(this.requestBasicContactForm)) {
        this.requestStore.listaFormulariosConsumo[REQUEST_BASIC_CONTACT] = null;
      } else if (data !== 'EIC' && !this.requestStore.listaFormulariosConsumo.includes(this.requestBasicContactForm)) {
        this.requestStore.setFormularioConsumo(this.requestBasicContactForm, REQUEST_BASIC_CONTACT);
      }
    }
  }
  @Output() public changeContinueStatus = new EventEmitter<any>();
  @Output() public sendToClient = new EventEmitter<any>();

  public optionalEmail = false;
  public optionalPhone = false;
  public optionalSurname = false;
  public requestBasicContactForm: FormGroup;
  public disabledButtonBasicContact: boolean = true;
  public operativeValue: string = '';

  //PE_725 Fenix
  fieldsDisabled: StatesFieldsFrontDTO[];

  constructor(
    private requestStore: RequestsSaveSendStore,
    private formBuilder: FormBuilder,
    private customValidators: CustomValidatorsService
  ) {}

  ngOnInit(): void {
    this.requestBasicContactForm = this.formBuilder.group({
      name: ['', Validators.required],
      middleName: ['', Validators.required],
      surname: ['', Validators.required],
      nif: ['', [Validators.required, this.customValidators.isNifNieValid]],
      telephone: ['', [Validators.required, this.customValidators.isTelephoneValid]],
      email: ['', [Validators.required, this.customValidators.validateEmail]],
    });

    if (this.requestStore.getMarcaFormulario() === FORM_BP) {
      this.requestStore.setFormularioBonpreu(this.requestBasicContactForm, REQUEST_BASIC_CONTACT);
    } else if (this.requestStore.getMarcaFormulario() === FORM_MG_NO_SHOP) {
      this.requestStore.setFormularioMangoNoShopping(this.requestBasicContactForm, REQUEST_BASIC_CONTACT);
    } else if (this.requestStore.getMarcaFormulario() === FORM_MG) {
      this.requestStore.setFormularioMg(this.requestBasicContactForm, REQUEST_BASIC_CONTACT);
    } else {
      this.requestStore.setFormularioConsumo(this.requestBasicContactForm, REQUEST_BASIC_CONTACT);
    }

    this.requestBasicContactForm.statusChanges.subscribe(() => {
      if (this.requestBasicContactForm.valid) {
        if (this.requestStore.getMarcaFormulario() === FORM_MG) {
          this.changeContinueStatus.emit({
            form: <FormGroup>this.requestBasicContactForm,
            id: REQUEST_BASIC_CONTACT,
          });
        } else {
          this.changeContinueStatus.emit({ form: <FormGroup>this.requestBasicContactForm, id: REQUEST_BASIC_CONTACT });
        }
      }
      this.updateDisabledSendButton();
    });

    const form = this.requestBasicContactForm.controls;

    form.telephone.valueChanges.subscribe(() => {
      this.updateValuePhone(false);
    });

    form.email.valueChanges.subscribe(() => {
      this.updateValueEmail(false);
    });
    if (this.mode === REQUEST_MODE_VIEW) {
      if (
        this.state.id !== PENDIENTES_DE_DATOS ||
        (this.state.id === PENDIENTES_DE_DATOS && this.operativeValue === 'EIC')
      ) {
        this.requestBasicContactForm.disable();
      }
      this.setValuesToForm();
    } else if (this.mode === REQUEST_MODE_EDIT) {
      this.setValuesToForm();
    }

    this.requestStore.listaFormulariosConsumo[POINT_OF_SALE]?.statusChanges.subscribe(() => {
      this.updateDisabledSendButton();
    });

    this.requestStore.listaFormulariosConsumo[REQUEST_DATA]?.statusChanges.subscribe(() => {
      this.updateDisabledSendButton();
    });

    this.requestStore.listaFormulariosConsumo[FINANCE]?.statusChanges.subscribe(() => {
      this.updateDisabledSendButton();
    });
  }

  updateValuePhone(blur: boolean) {
    const form = this.requestBasicContactForm.controls;
    if (this.isFieldValid(form.telephone) && this.isFieldValid(form.email)) {
      this.requestBasicContactForm.controls.email.setValidators([
        Validators.required,
        this.customValidators.validateEmail,
      ]);
      this.optionalEmail = false;
    } else if (this.isFieldValid(form.telephone) && !this.isFieldValid(form.email)) {
      this.requestBasicContactForm.controls.email.clearValidators();
      this.requestBasicContactForm.controls.email.setValidators(this.customValidators.validateEmail);
      if (blur) this.requestBasicContactForm.controls.email.updateValueAndValidity();
      this.requestBasicContactForm.controls.email.markAsUntouched();
      this.optionalEmail = true;
    } else if (!this.isFieldValid(form.telephone) && this.isFieldValid(form.email)) {
      this.requestBasicContactForm.controls.telephone.clearValidators();
      this.requestBasicContactForm.controls.telephone.setValidators(this.customValidators.isTelephoneValid);
      this.requestBasicContactForm.controls.email.setValidators([
        Validators.required,
        this.customValidators.validateEmail,
      ]);
      if (blur) this.requestBasicContactForm.controls.telephone.updateValueAndValidity();
      this.requestBasicContactForm.controls.telephone.markAsUntouched();
      this.optionalEmail = false;
      this.optionalPhone = true;
    } else {
      this.requestBasicContactForm.controls.email.setValidators([
        Validators.required,
        this.customValidators.validateEmail,
      ]);
      this.optionalEmail = false;
    }
  }

  updateValueEmail(blur: boolean) {
    const form = this.requestBasicContactForm.controls;
    if (this.isFieldValid(form.telephone) && this.isFieldValid(form.email)) {
      this.requestBasicContactForm.controls.telephone.setValidators([
        Validators.required,
        this.customValidators.isTelephoneValid,
      ]);
      this.optionalPhone = false;
    } else if (this.isFieldValid(form.email) && !this.isFieldValid(form.telephone)) {
      this.requestBasicContactForm.controls.telephone.clearValidators();
      this.requestBasicContactForm.controls.telephone.setValidators(this.customValidators.isTelephoneValid);
      if (blur) this.requestBasicContactForm.controls.telephone.updateValueAndValidity();
      this.requestBasicContactForm.controls.telephone.markAsUntouched();
      this.optionalPhone = true;
    } else if (!this.isFieldValid(form.email) && this.isFieldValid(form.telephone)) {
      this.requestBasicContactForm.controls.email.clearValidators();
      this.requestBasicContactForm.controls.email.setValidators(this.customValidators.validateEmail);
      if (blur) this.requestBasicContactForm.controls.email.updateValueAndValidity();
      this.requestBasicContactForm.controls.email.markAsUntouched();
      this.optionalEmail = true;
      this.requestBasicContactForm.controls.telephone.setValidators([
        Validators.required,
        this.customValidators.isTelephoneValid,
      ]);
      this.optionalPhone = false;
    } else {
      this.requestBasicContactForm.controls.telephone.setValidators([
        Validators.required,
        this.customValidators.isTelephoneValid,
      ]);
      this.optionalPhone = false;
    }
  }

  setValuesToForm() {
    this.requestBasicContactForm.controls.name.setValue(this.request.name);
    this.requestBasicContactForm.controls.middleName.setValue(this.request.surname);
    this.requestBasicContactForm.controls.surname.setValue(this.request.secondSurname);
    this.requestBasicContactForm.controls.nif.setValue(this.request.documentId);
    this.requestBasicContactForm.controls.telephone.setValue(this.request.mobileTel);
    this.requestBasicContactForm.controls.email.setValue(this.request.email);
  }

  isFieldValid(field: AbstractControl): boolean {
    return field.value !== null && field.value !== '' && field.valid;
  }

  public updateDisabledSendButton() {
    //TODO: En la próxima minor release a la 13.0.2. de la líbreria Angular, la property Status pasará de ser String a FormControlStatus
    //Change - https://github.com/angular/angular/pull/42952
    //Issue - https://github.com/angular/angular/issues/44176
    const isInvalid = this.requestStore.listaFormulariosConsumo.findIndex(
      (form, i) =>
        (i === POINT_OF_SALE ||
          i === REQUEST_DATA ||
          i === FINANCE ||
          i === FINANCE_AMOUNT ||
          i === REQUEST_BASIC_CONTACT) &&
        form?.status === 'INVALID'
    );
    if (isInvalid >= 0) {
      this.disabledButtonBasicContact = true;
    } else {
      let invalid: boolean = false;
      let valuesForm: any = this.requestBasicContactForm.value;
      for (const property in valuesForm) {
        if (
          property !== 'surname' &&
          property !== 'telephone' &&
          this.optionalPhone &&
          property !== 'email' &&
          this.optionalEmail
        ) {
          if (valuesForm[property].length === 0 && (valuesForm[property] === '' || valuesForm[property] === null)) {
            invalid = true;
          }
        }
      }

      if (invalid) {
        this.disabledButtonBasicContact = true;
      } else {
        this.disabledButtonBasicContact = false;
      }
    }
  }

  checkNameAndSurname(value: any, element: any) {
    const inputForm = typeof element === 'string' ? element : element?.getAttribute('formControlName');
    let inputValue = typeof value === 'string' ? value : value?.target.value;

    if (this.optionalSurname == false) {
      this.requestBasicContactForm.controls.surname.setValidators([Validators.required]);
    } else {
      this.requestBasicContactForm.controls.surname.setValidators([]);
    }
    if (inputValue.length > 0) {
      if (!this.customValidators.validateNameAndSurname(inputValue)) {
        this.requestBasicContactForm.controls[inputForm].setErrors({ incorrect: true });
      } else {
        this.requestBasicContactForm.controls[inputForm].setErrors(null);
      }
    }
  }

  sendRequestToClient() {
    //desencadenar un evento en el request que recoja todos los datos y los envie a IC
    this.sendToClient.emit();
  }

  isNif(value: string) {
    if (this.customValidators.isNie(value)) {
      this.requestBasicContactForm.controls.surname.setValidators([]);
      this.optionalSurname = true;
    } else {
      this.requestBasicContactForm.controls.surname.setValidators([Validators.required]);
      this.optionalSurname = false;
    }
    this.requestBasicContactForm.controls.surname.updateValueAndValidity();
  }

  ngAfterContentChecked() {
    //PE_725 Fenix
    if (this.mode === REQUEST_MODE_EDIT && this.request !== null && this.request.fieldsDisable !== null) {
      this.fieldsDisabled = this.request.fieldsDisable;
      this.disableFieldsByCore();
    }
  }

  private disableFieldsByCore() {
    if (this.fieldsDisabled !== null && this.fieldsDisabled !== undefined) {
      const form = this.requestBasicContactForm;
      this.fieldsDisabled.forEach((field) => {
        const toDisable = form.get(field.campoName);
        if (toDisable !== null && toDisable !== undefined) {
          toDisable.disable();
        }
      });
    }
  }
}
